import _regeneratorRuntime from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import qs from 'qs';
var options = {
  credentials: 'include'
};
export function getCourses(trial) {
  return (
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(dispatch) {
        var response, data, courses, pages, i, offset, _response, _data, _courses;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return fetch(process.env.REACT_APP_API_URL + '/api/course_entity/course_entity', options);

              case 3:
                response = _context.sent;

                if (!response.ok) {
                  _context.next = 33;
                  break;
                }

                _context.next = 7;
                return response.json();

              case 7:
                data = _context.sent;

                // If this is a trial user, only include trial courses
                if (trial) {
                  courses = data.data.filter(function (course) {
                    return course.attributes.field_trial === true;
                  });
                } else {
                  courses = data.data;
                }

                pages = Math.ceil(data.meta.count / 50);
                dispatch({
                  type: 'GET_COURSES',
                  data: courses,
                  fetched: !(pages > 1)
                });
                i = 1;

              case 12:
                if (!(i < pages)) {
                  _context.next = 33;
                  break;
                }

                offset = i * 50;
                _context.prev = 14;
                _context.next = 17;
                return fetch(process.env.REACT_APP_API_URL + '/api/course_entity/course_entity?page%5Boffset%5D=' + offset + '&page%5Blimit%5D=50', options);

              case 17:
                _response = _context.sent;

                if (!_response.ok) {
                  _context.next = 25;
                  break;
                }

                _context.next = 21;
                return _response.json();

              case 21:
                _data = _context.sent;
                _courses = void 0; // If this is a trial user, only include trial courses

                if (trial) {
                  _courses = _data.data.filter(function (course) {
                    return course.attributes.field_trial === true;
                  });
                } else {
                  _courses = _data.data;
                }

                dispatch({
                  type: 'GET_COURSES',
                  data: _courses,
                  fetched: i === pages - 1
                });

              case 25:
                _context.next = 30;
                break;

              case 27:
                _context.prev = 27;
                _context.t0 = _context["catch"](14);
                console.log(_context.t0);

              case 30:
                i++;
                _context.next = 12;
                break;

              case 33:
                _context.next = 38;
                break;

              case 35:
                _context.prev = 35;
                _context.t1 = _context["catch"](0);
                console.log(_context.t1);

              case 38:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 35], [14, 27]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()
  );
}
export function getLearningPaths() {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(dispatch, getState) {
        var response, data, paths, excludedPaths, excludedPathIds, filteredPaths;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return fetch(process.env.REACT_APP_API_URL + '/api/learning_path/learning_path?include=field_image,field_type', options);

              case 3:
                response = _context2.sent;

                if (!response.ok) {
                  _context2.next = 13;
                  break;
                }

                _context2.next = 7;
                return response.json();

              case 7:
                data = _context2.sent;
                paths = data.data;
                excludedPaths = getState().session.group && getState().session.group.field_learning_path_to_exclude;
                excludedPathIds = excludedPaths && excludedPaths.map(function (path) {
                  return path.target_uuid;
                });
                filteredPaths = excludedPathIds && paths.filter(function (path) {
                  return !excludedPathIds.includes(path.id);
                });
                dispatch({
                  type: 'GET_LEARNING_PATHS',
                  data: filteredPaths ? filteredPaths : paths,
                  included: data.included,
                  fetched: true
                });

              case 13:
                _context2.next = 18;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2["catch"](0);
                console.log(_context2.t0);

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 15]]);
      }));

      return function (_x2, _x3) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
}
export function getUserLearningPaths(user) {
  return (
    /*#__PURE__*/
    function () {
      var _ref3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(dispatch, getState) {
        var query, response, data;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                query = {
                  filter: {
                    'field_user.id': user.id
                  }
                };
                _context3.next = 4;
                return fetch(process.env.REACT_APP_API_URL + '/api/user_learning_path/user_learning_path?' + qs.stringify(query), options);

              case 4:
                response = _context3.sent;

                if (!response.ok) {
                  _context3.next = 10;
                  break;
                }

                _context3.next = 8;
                return response.json();

              case 8:
                data = _context3.sent;
                dispatch({
                  type: 'GET_USER_LEARNING_PATHS',
                  data: data.data,
                  fetched: true
                });

              case 10:
                _context3.next = 15;
                break;

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3["catch"](0);
                console.log(_context3.t0);

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 12]]);
      }));

      return function (_x4, _x5) {
        return _ref3.apply(this, arguments);
      };
    }()
  );
}
export function getCategories() {
  return (
    /*#__PURE__*/
    function () {
      var _ref4 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(dispatch) {
        var response, data;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return fetch(process.env.REACT_APP_API_URL + '/api/taxonomy_term/category', options);

              case 3:
                response = _context4.sent;

                if (!response.ok) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 7;
                return response.json();

              case 7:
                data = _context4.sent;
                dispatch({
                  type: 'GET_CATEGORIES',
                  data: data
                });

              case 9:
                _context4.next = 14;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4["catch"](0);
                console.log(_context4.t0);

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[0, 11]]);
      }));

      return function (_x6) {
        return _ref4.apply(this, arguments);
      };
    }()
  );
}
export function getTeacherImage(uid) {
  return (
    /*#__PURE__*/
    function () {
      var _ref5 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(dispatch) {
        var response, status;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return fetch(process.env.REACT_APP_API_URL + '/api/user/user/' + uid + '?include=user_picture', {
                  credentials: 'include'
                });

              case 3:
                response = _context5.sent;

                if (!response.ok) {
                  _context5.next = 10;
                  break;
                }

                _context5.next = 7;
                return response.json();

              case 7:
                status = _context5.sent;

                if (!status) {
                  _context5.next = 10;
                  break;
                }

                return _context5.abrupt("return", dispatch({
                  type: 'GET_TEACHER_IMAGE',
                  data: status.included[0]
                }));

              case 10:
                _context5.next = 15;
                break;

              case 12:
                _context5.prev = 12;
                _context5.t0 = _context5["catch"](0);
                console.log(_context5.t0);

              case 15:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[0, 12]]);
      }));

      return function (_x7) {
        return _ref5.apply(this, arguments);
      };
    }()
  );
}
export function getAssessment(id) {
  return (
    /*#__PURE__*/
    function () {
      var _ref6 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(dispatch) {
        var response, data;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return fetch(process.env.REACT_APP_API_URL + '/api/assessment_entity/assessment_entity/' + id + '?include=field_teacher,field_image_submission', options);

              case 3:
                response = _context6.sent;

                if (!response.ok) {
                  _context6.next = 9;
                  break;
                }

                _context6.next = 7;
                return response.json();

              case 7:
                data = _context6.sent;

                if (data) {
                  dispatch({
                    type: 'GET_ASSESSMENT',
                    data: data.data,
                    included: data.included
                  });
                }

              case 9:
                _context6.next = 14;
                break;

              case 11:
                _context6.prev = 11;
                _context6.t0 = _context6["catch"](0);
                console.log(_context6.t0);

              case 14:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[0, 11]]);
      }));

      return function (_x8) {
        return _ref6.apply(this, arguments);
      };
    }()
  );
}
export function getAssessments(dispatch) {
  return (
    /*#__PURE__*/
    function () {
      var _ref7 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7(dispatch, getState) {
        var user, query, response, data, pages, i, _response2, _data2;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                user = getState().session.user;
                query = {
                  filter: {
                    'field_teacher.id': user.id
                  }
                };
                _context7.next = 5;
                return fetch(process.env.REACT_APP_API_URL + '/api/assessment_entity/assessment_entity?' + qs.stringify(query), options);

              case 5:
                response = _context7.sent;

                if (!response.ok) {
                  _context7.next = 32;
                  break;
                }

                _context7.next = 9;
                return response.json();

              case 9:
                data = _context7.sent;
                pages = Math.ceil(Number(data.meta.count) / 50);
                dispatch({
                  type: 'GET_ASSESSMENTS',
                  data: data.data,
                  fetched: !(pages > 1)
                });
                i = 1;

              case 13:
                if (!(i < pages)) {
                  _context7.next = 32;
                  break;
                }

                _context7.prev = 14;
                query = {
                  filter: {
                    'field_teacher.id': user.id
                  },
                  page: {
                    'offset': i * 50
                  }
                };
                _context7.next = 18;
                return fetch(process.env.REACT_APP_API_URL + '/api/assessment_entity/assessment_entity?' + qs.stringify(query), options);

              case 18:
                _response2 = _context7.sent;

                if (!_response2.ok) {
                  _context7.next = 24;
                  break;
                }

                _context7.next = 22;
                return _response2.json();

              case 22:
                _data2 = _context7.sent;
                dispatch({
                  type: 'GET_ASSESSMENTS',
                  data: _data2.data,
                  page: i,
                  fetched: i === pages - 1
                });

              case 24:
                _context7.next = 29;
                break;

              case 26:
                _context7.prev = 26;
                _context7.t0 = _context7["catch"](14);
                console.log(_context7.t0);

              case 29:
                i++;
                _context7.next = 13;
                break;

              case 32:
                _context7.next = 37;
                break;

              case 34:
                _context7.prev = 34;
                _context7.t1 = _context7["catch"](0);
                console.log(_context7.t1);

              case 37:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[0, 34], [14, 26]]);
      }));

      return function (_x9, _x10) {
        return _ref7.apply(this, arguments);
      };
    }()
  );
}
export function deleteAssessment(id, session) {
  var options = {
    credentials: 'include',
    method: 'DELETE',
    headers: new Headers({
      'Content-Type': 'application/vnd.api+json',
      'Accept': 'application/vnd.api+json',
      'X-CSRF-Token': session.token
    })
  };
  return (
    /*#__PURE__*/
    function () {
      var _ref8 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8(dispatch) {
        var response, data;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return fetch(process.env.REACT_APP_API_URL + '/api/assessment_entity/assessment_entity/' + id, options);

              case 3:
                response = _context8.sent;

                if (!response.ok) {
                  _context8.next = 9;
                  break;
                }

                _context8.next = 7;
                return response.json();

              case 7:
                data = _context8.sent;
                return _context8.abrupt("return", dispatch({
                  type: 'DELETE_ASSESSMENT',
                  data: data.data
                }));

              case 9:
                _context8.next = 13;
                break;

              case 11:
                _context8.prev = 11;
                _context8.t0 = _context8["catch"](0);

              case 13:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, null, [[0, 11]]);
      }));

      return function (_x11) {
        return _ref8.apply(this, arguments);
      };
    }()
  );
}
export function updateAssessment(id, session, status) {
  // Set our initial options for the patch
  var options = {
    credentials: 'include',
    method: 'PATCH',
    headers: new Headers({
      'Content-Type': 'application/vnd.api+json',
      'Accept': 'application/vnd.api+json',
      'X-CSRF-Token': session.token
    })
  }; // Set the assessment status to grading_in_progress

  options.body = JSON.stringify({
    "data": {
      "id": id,
      "type": "assessment_entity--assessment_entity",
      "attributes": {
        "field_status": status,
        "field_last_updated_by": [{
          value: session.user.attributes.uid
        }]
      }
    }
  });
  return (
    /*#__PURE__*/
    function () {
      var _ref9 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9(dispatch) {
        var response, data;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                _context9.next = 3;
                return fetch(process.env.REACT_APP_API_URL + '/api/assessment_entity/assessment_entity/' + id, options);

              case 3:
                response = _context9.sent;

                if (!response.ok) {
                  _context9.next = 9;
                  break;
                }

                _context9.next = 7;
                return response.json();

              case 7:
                data = _context9.sent;
                return _context9.abrupt("return", dispatch({
                  type: 'UPDATE_ASSESSMENT',
                  data: data.data
                }));

              case 9:
                _context9.next = 14;
                break;

              case 11:
                _context9.prev = 11;
                _context9.t0 = _context9["catch"](0);
                console.log(_context9.t0);

              case 14:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, null, [[0, 11]]);
      }));

      return function (_x12) {
        return _ref9.apply(this, arguments);
      };
    }()
  );
}
export function getCourse(id) {
  return (
    /*#__PURE__*/
    function () {
      var _ref10 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10(dispatch) {
        var response, status;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                _context10.next = 3;
                return fetch(process.env.REACT_APP_API_URL + '/api/course_entity/course_entity/' + id, {
                  credentials: 'include'
                });

              case 3:
                response = _context10.sent;

                if (!response.ok) {
                  _context10.next = 10;
                  break;
                }

                _context10.next = 7;
                return response.json();

              case 7:
                status = _context10.sent;

                if (!status) {
                  _context10.next = 10;
                  break;
                }

                return _context10.abrupt("return", dispatch({
                  type: 'GET_COURSE',
                  data: status.data
                }));

              case 10:
                _context10.next = 15;
                break;

              case 12:
                _context10.prev = 12;
                _context10.t0 = _context10["catch"](0);
                console.log(_context10.t0);

              case 15:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, null, [[0, 12]]);
      }));

      return function (_x13) {
        return _ref10.apply(this, arguments);
      };
    }()
  );
}
export function getBadges() {
  return (
    /*#__PURE__*/
    function () {
      var _ref11 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11(dispatch, getState) {
        var response, status;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                _context11.next = 3;
                return fetch(process.env.REACT_APP_API_URL + '/api/badges_entity/badges_entity?include=field_badge_image', {
                  credentials: 'include'
                });

              case 3:
                response = _context11.sent;

                if (!response.ok) {
                  _context11.next = 10;
                  break;
                }

                _context11.next = 7;
                return response.json();

              case 7:
                status = _context11.sent;

                if (!status) {
                  _context11.next = 10;
                  break;
                }

                return _context11.abrupt("return", dispatch({
                  type: 'GET_BADGES',
                  badges: status.data,
                  badgeImages: status.included,
                  fetched: true
                }));

              case 10:
                _context11.next = 15;
                break;

              case 12:
                _context11.prev = 12;
                _context11.t0 = _context11["catch"](0);
                console.log(_context11.t0);

              case 15:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, null, [[0, 12]]);
      }));

      return function (_x14, _x15) {
        return _ref11.apply(this, arguments);
      };
    }()
  );
}
export function submitAssessment(args) {
  var course = args.course,
      content = args.content,
      status = args.status,
      assessmentId = args.assessmentId; // Set our initial options for the patch

  var options = {
    credentials: 'include',
    method: 'PATCH'
  }; // The teacher Assessment component will not pass a third status argument to this function,
  // so we'll take the assessment response and always update the assessment to "submitted"

  if (!status) {
    return (
      /*#__PURE__*/
      function () {
        var _ref12 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee12(dispatch, getState) {
          var attributes, response;
          return _regeneratorRuntime.wrap(function _callee12$(_context12) {
            while (1) {
              switch (_context12.prev = _context12.next) {
                case 0:
                  options.headers = new Headers({
                    'Content-Type': 'application/vnd.api+json',
                    'Accept': 'application/vnd.api+json',
                    'X-CSRF-Token': getState().session.token
                  });

                  if (course.attributes.field_submission_type === "Multiple Choice") {
                    attributes = {
                      "field_multiple_choice_submission": content,
                      "field_status": "submitted"
                    };
                  } else if (course.attributes.field_submission_type === "Text" || !course.attributes.field_submission_type) {
                    attributes = {
                      "field_text_submission": content,
                      "field_status": "submitted"
                    };
                  } else if (course.attributes.field_submission_type === "URL") {
                    attributes = {
                      "field_document_url": content,
                      "field_status": "submitted"
                    };
                  }

                  attributes.field_last_updated_by = [{
                    value: getState().session.user.attributes.drupal_internal__uid
                  }];
                  options.body = JSON.stringify({
                    "data": {
                      "id": assessmentId,
                      "type": "assessment_entity--assessment_entity",
                      "attributes": attributes
                    }
                  });
                  _context12.prev = 4;
                  _context12.next = 7;
                  return fetch(process.env.REACT_APP_API_URL + '/api/assessment_entity/assessment_entity/' + assessmentId, options);

                case 7:
                  response = _context12.sent;

                  if (!response.ok) {
                    _context12.next = 10;
                    break;
                  }

                  return _context12.abrupt("return", dispatch({
                    type: 'SUBMIT_ASSESSMENT'
                  }));

                case 10:
                  _context12.next = 15;
                  break;

                case 12:
                  _context12.prev = 12;
                  _context12.t0 = _context12["catch"](4);
                  console.log(_context12.t0);

                case 15:
                case "end":
                  return _context12.stop();
              }
            }
          }, _callee12, null, [[4, 12]]);
        }));

        return function (_x16, _x17) {
          return _ref12.apply(this, arguments);
        };
      }()
    );
  } // The Review component will update the status to either completed or in_progress
  else if (status) {
      return (
        /*#__PURE__*/
        function () {
          var _ref13 = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee13(dispatch, getState) {
            var response;
            return _regeneratorRuntime.wrap(function _callee13$(_context13) {
              while (1) {
                switch (_context13.prev = _context13.next) {
                  case 0:
                    options.headers = new Headers({
                      'Content-Type': 'application/vnd.api+json',
                      'Accept': 'application/vnd.api+json',
                      'X-CSRF-Token': getState().session.token
                    });
                    options.body = JSON.stringify({
                      "data": {
                        "id": assessmentId,
                        "type": "assessment_entity--assessment_entity",
                        "attributes": {
                          "field_status": status,
                          "field_comments": content,
                          "field_last_updated_by": [{
                            value: getState().session.user.attributes.drupal_internal__uid
                          }]
                        }
                      }
                    });
                    _context13.prev = 2;
                    _context13.next = 5;
                    return fetch(process.env.REACT_APP_API_URL + '/api/assessment_entity/assessment_entity/' + assessmentId, options);

                  case 5:
                    response = _context13.sent;

                    if (!response.ok) {
                      _context13.next = 8;
                      break;
                    }

                    return _context13.abrupt("return", dispatch({
                      type: 'SUBMIT_ASSESSMENT'
                    }));

                  case 8:
                    _context13.next = 13;
                    break;

                  case 10:
                    _context13.prev = 10;
                    _context13.t0 = _context13["catch"](2);
                    console.log(_context13.t0);

                  case 13:
                  case "end":
                    return _context13.stop();
                }
              }
            }, _callee13, null, [[2, 10]]);
          }));

          return function (_x18, _x19) {
            return _ref13.apply(this, arguments);
          };
        }()
      );
    }
}